import React, { useState } from "react";

const Modal = ({ isOpen, onClose, number, title, description }) => {
  const [size, setSize] = useState(0);

  const getSize = (url) => {
    const img = new Image();
    img.onload = () => {
      setSize(img.width / img.height);
    };
    img.src = url;
  };

  const Imagen = () => {
    getSize(`../../../images/${number}.jpg`);
    if (size > 1) {
      return (
        <img
          className="m-img"
          src={`../../../images/${number}.jpg`}
          alt={`Figurita número ${number}. ${title} `}
          width="350"
        />
      );
    } else {
      return (
        <img
          className="m-img"
          src={`../../../images/${number}.jpg`}
          alt={`Figurita número ${number}. ${title} `}
          height="300"
        />
      );
    }
  };
  return (
    <>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <div className="modal-card">
            <p className="close-btn" onClick={onClose}>
              &times;
            </p>
            <h2>Figurita {number}</h2>
            <Imagen />
            <h3 className="m-title">{title}</h3>
            <p className="m-description">{description}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
